import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Input, Button, Paper, PhoneInput, inputValidation, showSuccess } from 'components';
import { showApiError } from 'utils';
import { createFranchisee, updateFranchisee } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FranchiseeDataForm = function FranchiseeDataForm(_ref) {
  var data = _ref.data,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;

  var initialFormData = _objectSpread({}, data);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var values, method, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = _ref2.values;
              method = data ? updateFranchisee : createFranchisee;
              params = data ? [data === null || data === void 0 ? void 0 : data.id, _objectSpread(_objectSpread({}, data), values)] : [values];
              _context.next = 5;
              return method.apply(void 0, params);

            case 5:
              _yield$method = _context.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 11:
              showSuccess("\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u044F\u0442 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A ".concat(data ? 'реадактиран' : 'създаден', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onSubmit) && onSubmit(res);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialFormData
  }, ___EmotionJSX(Paper, {
    header: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "name",
    label: "\u0418\u043C\u0435",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "address",
    label: "\u0410\u0434\u0440\u0435\u0441",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "mol_type",
    label: "\u0422\u0438\u043F \u043C\u043E\u043B",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "mol",
    label: "\u041C\u043E\u043B",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "eik",
    label: "\u0415\u0418\u041A",
    required: true
  })))), ___EmotionJSX(Paper, {
    header: "\u0414\u0430\u043D\u043D\u0438 \u0437\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "email",
    label: "\u0418\u043C\u0435\u0439\u043B",
    validate: inputValidation('email')
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(PhoneInput, {
    required: true,
    formId: "phone",
    label: "\u041C\u043E\u0431\u0438\u043B\u0435\u043D"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "fax",
    label: "\u0424\u0430\u043A\u0441"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "url",
    label: "\u0421\u0430\u0439\u0442"
  })))), ___EmotionJSX(Paper, {
    header: "\u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    leftIcon: {
      iconName: 'la la-percent'
    },
    formId: "credit_interest_percent",
    label: "\u041B\u0438\u0445\u0432\u0435\u043D \u043F\u0440\u043E\u0446.",
    validate: inputValidation('percentInt', 'required')
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    leftIcon: {
      iconName: 'la la-percent'
    },
    formId: "royalties_percent",
    label: "\u041A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u043D\u0430",
    validate: inputValidation('percentInt', 'required')
  })))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref4) {
    var onSubmit = _ref4.onSubmit;
    return ___EmotionJSX(React.Fragment, null, _isFunction(onClose) && ___EmotionJSX(Button, {
      type: "secondary",
      onClick: onClose,
      margin: "0 1em 0 0"
    }, "\u041D\u0430\u0437\u0430\u0434"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438"));
  })));
};

FranchiseeDataForm.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  data: PropTypes.object
};
export default FranchiseeDataForm;